<template>
  <div style="display: flex;">
    <Transition name="fade">
      <div id="exportOverlay" v-if="exporting" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.4); z-index: 9999;"></div>
    </Transition>
    <div style="position: relative; flex-grow: 1">
      <div style="position: absolute; padding: 10px; padding-right: 50px; z-index: 1; display: flex; flex-wrap: wrap; row-gap: 10px; pointer-events: none;">
        <v-btn  href="https://rp-database.com/docs/features/map" target="_blank" depressed class="py-4 pl-3 pr-4 mr-3 map-help" style=" margin-left: 180px; pointer-events: all;"
        color="white" >
          <v-icon color="primary" style="font-size: large;">mdi-information</v-icon>
          <span class="ml-1" style=" font-weight: 500;">Map help</span>

        </v-btn>

        <div class="mr-3" v-on="on" style="background-color: white; border-radius: 2px;">
         <v-btn @click="exportPDF()" depressed class="py-4 pl-3 pr-4 map-property" style=" pointer-events: all;" :loading="exporting" :disabled="loading"
        color="white" >
          <v-icon color="primary" style="font-size: large;">mdi-file</v-icon>
          <span class="ml-1" style=" font-weight: 500;">Export Map</span>

        </v-btn>
        </div>

        <v-tooltip v-if="!showAllMarkers" bottom>
          <template v-slot:activator="{ on }">
            <div class="mr-3" v-on="on" style="background-color: white; border-radius: 2px;">
              <v-btn target="_blank" depressed disabled class="py-4 pl-3 pr-4 map-property" color="grey lighten-2" style="pointer-events: all;">
                <v-icon color="primary" style="font-size: large;">mdi-home-plus</v-icon>
                <span class="ml-1" style=" font-weight: 500;">New Property/Scheme</span>
              </v-btn>
            </div>
          </template>
          <span>To avoid creating duplicate property or schemes, you must enable `Show RPD Markers` in the sidebar first.</span>
        </v-tooltip>

        <v-menu v-else-if="!placingMarker" offset-y>
          <template v-slot:activator="{ on }">
            <v-btn target="_blank" v-on="on" depressed class="py-4 pl-3 pr-4 mr-3 map-property" color="white" style="pointer-events: all;">
              <v-icon color="primary" style="font-size: large;">mdi-home-plus</v-icon>
              <span class="ml-1" style=" font-weight: 500;">New Property/Scheme</span>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="addProperty">
              <v-list-item-title>New Standalone Property</v-list-item-title>
            </v-list-item>
            <v-list-item @click="addProperty('scheme')">
              <v-list-item-title>New Scheme</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        

        <v-btn v-else target="_blank" @click="placingMarker = false"  depressed class="py-4 pl-3 pr-4 mr-3 map-property" color="grey lighten-3" style="pointer-events: all;">
            <v-icon style="font-size: large;">mdi-crosshairs</v-icon>
            <span class="ml-1" style=" font-weight: 500;">Click Map to Select Location</span>
        </v-btn>
        <v-card style=" border-radius: 2px;box-shadow: 0 0 6px 0 rgba(0,0,0,0.3);">
          <v-card-title class="py-1">
            <!-- <span class="text-primary-700">Markers</span>
            <v-progress-circular v-if="loading" indeterminate size="25" class="mr-2"></v-progress-circular>
            <v-btn icon @click="refreshMap" :loading="loading" class="ml-1 mr-4">
              <v-icon title="Reset" >mdi-refresh</v-icon>
            </v-btn>
            <v-spacer></v-spacer> -->

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span v-on="on" class="font-weight-light text-overline" v-show="zoomLevel>=10">Visible {{createdMarkers.length}}/{{createdMarkers.length + ignoredMarkerCount}}</span>
              </template>
              <span>Markers are hidden when zoomed out to ensure performance. Zoom in more to display all markers for the visible area.</span>
            </v-tooltip>
            <span v-show="zoomLevel < 10" class="font-weight-light text-overline">Zoom in to see markers</span>
          </v-card-title>
        </v-card>
      </div>
      <GmapMap
        :center="center"
        :zoom="zoom"
        map-type-id="hybrid"
        style="height: calc(100vh - 48px);width: 100%; cursor:progress;"
        ref="map"
        :options="mapOptions"
        @click="addMarker"
      >

        <GmapMarker v-if="propertyMarker && placingMarker"
          :position="propertyMarker"
          :clickable="true"
          :draggable="true"
          @dragend="dragPropertyMarker"
        />

        <GmapCircle
          ref="circleRef4"
          v-if="(placeObject || schemeFilter) && showCircles"
          :center="searchLocation"
          :radius="14484"
          :visible="true"
          :options="{fillColor:'#8a7dbe',fillOpacity:0.2}"
        ></GmapCircle>
        <GmapCircle
          ref="circleRef3"
          v-if="(placeObject || schemeFilter) && showCircles"
          :center="searchLocation"
          :radius="9656"
          :visible="true"
          :options="{fillColor:'#8a7dbe',fillOpacity:0.2}"
        ></GmapCircle>
        <GmapCircle
          ref="circleRef2"
          v-if="(placeObject || schemeFilter) && showCircles"
          :center="searchLocation"
          :radius="4828"
          :visible="true"
          :options="{fillColor:'#8a7dbe',fillOpacity:0.2}"
        ></GmapCircle>
        <GmapCircle
          ref="circleRef1"
          v-if="(placeObject || schemeFilter) && showCircles"
          :center="searchLocation"
          :radius="2414"
          :visible="true"
          :options="{fillColor:'#8a7dbe',fillOpacity:0.2}"
        ></GmapCircle>

      </GmapMap>
      <v-btn @click="drawer = !drawer" class="map-filter-button" depressed color="white" :class="drawer ? 'filter-icon-border' : ''">
        <v-icon v-if="drawer">mdi-arrow-right</v-icon>
        <v-icon v-else>mdi-arrow-left</v-icon>
      </v-btn>

      <v-card v-if="placingMarker" style="position: absolute; bottom: 24px; right:70px; min-width: 300px;">
        <v-card-text style="min-height: 86px; display: flex; justify-content: center; align-items: center; flex-direction: column;">
          <!-- <template v-if="addressLoading">
            <v-skeleton-loader style="width: 100%;" class="address-loader"  type="list-item-two-line"></v-skeleton-loader>
          </template> -->
          <template v-if="!propertyMarker">
            <div style="width: 100%; display: flex; align-items: center;">
              <span class="text-center text-overline">Click on the map to select a location</span>
              <v-spacer></v-spacer>
              <v-btn class="ml-2 mr-0" width="25" height="25" icon @click="placingMarker = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
            
          </template>
          <template v-else-if="validAddress">
            <div style="width: 100%; display: flex; align-items: center;">
              <span v-if="propertyAddress.line1" class="text-h6">{{ propertyAddress.line1 }}</span>
              <span v-else style="width: 100%;">{{ compiledAddress }}</span>
              <v-spacer></v-spacer>
              <v-btn class="ml-2 mr-0" width="25" height="25" icon @click="placingMarker = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
            <span v-if="propertyAddress.line1" style="width: 100%;">{{ compiledAddress }}</span>
          </template>
          <template v-else>
            <div style="width: 100%; display: flex; align-items: center;">
              <span class="text-center text-overline">Invalid Location</span>
              <v-spacer></v-spacer>
              <v-btn class="ml-2 mr-0" width="25" height="25" icon @click="placingMarker = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
            
          </template>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn depressed @click="clearPropertyMarker">Clear</v-btn>
          <v-btn color="primary" :disabled="!validAddress" depressed @click="selectAddress">Select Address</v-btn>
        </v-card-actions>
      </v-card>

      <edit-scheme-dialog @deleted="deleteSchemeMarker" @property_marker_updated="updatePropertyMarker"
                          @marker_updated="updateSchemeMarker" ref="editSchemeDialog"></edit-scheme-dialog>
      <!-- <edit-standalone-property-dialog @marker_updated="updatePropertyMarker"
                                      ref="editStandalonePropertyDialog"></edit-standalone-property-dialog> -->
      <edit-property-dialog @marker_updated="updatePropertyMarker" @deleted="deletePropertyMarker" ref="editPropertyDialog"></edit-property-dialog>
      <create-layer-dialog ref="createLayerDialog" @created="addLayer"></create-layer-dialog>
      <demographic-info-dialog ref="demographicInfoDialog"></demographic-info-dialog>
      <charging-point-info-dialog ref="chargingPointInfoDialog"></charging-point-info-dialog>
      <add-property-dialog ref="addPropertyDialog" @added="mapAdded"></add-property-dialog>
      <add-scheme-dialog ref="addSchemeDialog" @added="mapAdded"></add-scheme-dialog>
      <!--        <v-overlay :value="loading">-->
      <!--            <v-progress-circular v-if="loading" indeterminate size="64"></v-progress-circular>-->
      <!--        </v-overlay>-->
    </div>
    <div v-if="drawer" class="map-nav-container">
      <template>
        <v-card-title>
          <span class="text-primary-700">Search</span>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>


          <!-- <div
            :class="'pb-2 pt-0 v-input v-input--hide-details theme--'+(this.$vuetify.theme.dark?'dark':'light')+' v-text-field v-text-field--single-line v-text-field--is-booted'">
            <div class="v-input__control">
              <div class="v-input__slot">
                <div class="v-text-field__slot">
                  <GmapAutocomplete ref="autocompleteRef" @input="place = $event.target.value"
                                    @place_changed="changePlace"></GmapAutocomplete>
                </div>
                <div class="v-input__append-inner">
                  <transition name="fade">
                    <div class="v-input__icon v-input__icon--append mr-2" v-if="place">

                        <v-icon @click="resetSearch">mdi-close</v-icon>
                    </div>
                  </transition>
                  <div class="v-input__icon v-input__icon--append">
                    <i aria-hidden="true"
                      :class="'v-icon notranslate mdi mdi-table-search theme--'+(this.$vuetify.theme.dark?'dark':'light')"></i>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
          <v-row>
            <v-col cols="12">
              <div class="v-input v-input--hide-details v-input--dense theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined">
                <div class="v-input__control">
                  <div class="v-input__slot">
                    <fieldset aria-hidden="true"><legend style="width: 45.75px;"><span class="notranslate">​</span></legend></fieldset>
                    <div class="v-text-field__slot">
                      <label for="input-680" class="v-label v-label--active theme--light" style="left: 0px; right: auto; position: absolute;">Autofill</label>
                      <!-- <label for="input-349" class="v-label theme--light" style="left: 0px; right: auto; position: absolute;">Street</label> -->


                      <!-- uk location bounds -->
                      <GmapAutocomplete :options="{componentRestrictions: {country: 'uk'}}"
                      
                      ref="autocompleteRef" @input="place = $event.target.value" @place_changed="changePlace"></GmapAutocomplete>
                    </div>
                    <div class="v-input__append-inner">
                      <transition name="fade">
                        <div class="v-input__icon v-input__icon--append" v-if="place">
                          
                            <v-icon @click="resetSearch">mdi-close</v-icon>
                        </div>
                      </transition>
                      </div>
                  </div>
                </div>
              </div>
            </v-col>
            <v-col cols="12">
              <v-autocomplete
                  v-model="schemeFilter"
                  :loading="schemes.loading"
                  :items="schemes.items"
                  :search-input.sync="schemes.search"
                  cache-items
                  flat
                  hide-no-data
                  outlined
                  dense
                  clearable
                  item-text="name"
                  item-value="id"
                  label="Scheme"
                  @change="changePlaceByScheme"
                >
                  <template v-slot:item="data">
                    <div class="v-list-item__title" style="max-width: 600px; font-size:medium" :title="data.item.name + ' (Properties: ' + data.item.properties_count + ')'">
                      {{ data.item.name }} (Properties: {{ data.item.properties_count }})
                    </div>
                  </template>
                </v-autocomplete>
            </v-col>
          </v-row>

          
          <v-row no-gutters>
            <v-col cols="12">
              <!-- <v-checkbox :ripple="false" v-model="showAllMarkers" class="ma-0 pa-0" label="Show RPD Markers"></v-checkbox> -->
               <!-- menu with checkboxes -->
              <v-checkbox :ripple="false" v-model="showAllMarkers" class="ma-0 pa-0" label="Show RPD Markers" @change="rpdMarkerToggle(showAllMarkers)">
                <template v-slot:label>
                      <span style="display: flex; align-items: center;">Show RPD Markers
                        <v-menu offset-y v-model="filterRPDMarkers" close-on-content-click :close-on-content-click="false" width="400px">
                          <template v-slot:activator="{ on, attrs }">
                              <v-icon class="ml-2" :color="RPDFilterActive ? 'red' : ''"  v-on="on" v-bind="attrs">mdi-chevron-down-circle</v-icon>
                          </template>
                          <v-card style="display: flex; flex-direction: column;">
                            <span class="py-3 px-4" style="font-size: large;" color="primary">Toggle RPD Markers</span>
                              <v-divider></v-divider>
                            <v-list width="375" class="py-0">
                              
                              <v-list-item>
                                  <v-checkbox :ripple="false" hide-details v-model="showMarkers" label="Retail Parks" value="Out of town"></v-checkbox>
                              </v-list-item>
                              <v-list-item>
                                  <v-checkbox :ripple="false" hide-details v-model="showMarkers" label="Leisure Parks" value="Leisure"></v-checkbox>
                              </v-list-item>
                              <v-list-item>
                                  <v-checkbox :ripple="false" hide-details v-model="showMarkers" label="Shopping Centres" value="Shopping centres"></v-checkbox>
                              </v-list-item>
                              <v-list-item>
                                  <v-checkbox :ripple="false" v-model="showMarkers" label="Standalone Properties" value="Standalone"></v-checkbox>
                              </v-list-item>
                            </v-list>
                          </v-card>
                        </v-menu>
                      </span>
                </template>
              </v-checkbox>
               
            </v-col>
            <v-col cols="6">

              <v-checkbox :ripple="false" v-model="groupByScheme" class="ma-0 pa-0">
                <template v-slot:label>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-on="on">Group By Scheme</span>
                    </template>
                    <span>Hide property markers if they are in a scheme</span>
                  </v-tooltip>
                </template>
              </v-checkbox>
            </v-col>
            <v-col cols="6">
              <v-checkbox :ripple="false" class="ma-0 pa-0" v-model="demographicsView" label="Demographics"></v-checkbox>
            </v-col>
            <v-col cols="6">
              <v-checkbox :ripple="false" class="ma-0 pa-0" v-model="chargingPointsView" label="Car Charging"></v-checkbox>
            </v-col>
            <v-col cols="6">
              <v-checkbox :ripple="false" hide-details class="ma-0 pa-0" v-model="googleLabels" label="Google Markers"></v-checkbox>
            </v-col>
            <v-col cols="6">
              <v-checkbox :ripple="false" hide-details v-if="(placeObject || schemeFilter)" class="ma-0 pa-0" v-model="showCircles">
                <template v-slot:label>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <span v-on="on">Radius(1.5, 3, 6, 9)</span>
                    </template>
                    <span>Radius circles are at 1.5 miles, 3 miles, 6 miles, and 9 miles.</span>
                  </v-tooltip>
                </template>
              </v-checkbox>
            </v-col>
          </v-row>

        </v-card-text>
      </template>
      <v-divider></v-divider>
      <v-card-text class="pa-0" style="overflow: hidden;">
        <v-card-title class="">
          <span class="text-primary-700 mr-4">Filters</span>
          <v-tooltip bottom v-if="!layersLoading && !layersUpdating" >
            <template v-slot:activator="{ on, attrs }">
              <span v-on="on" class="font-weight-light text-overline mr-2">Entities: {{layerMarkers.length}}</span>

            </template>
            <span>Markers for filters are always displayed on the map, if you cannot see all markers zoom out more.</span>
          </v-tooltip>
          <v-progress-circular v-else-if="layersLoading || layersUpdating" indeterminate size="25" class="mr-2"></v-progress-circular>
          <v-spacer></v-spacer>
          <v-btn outlined text @click="$refs.createLayerDialog.showDialog()">
            Add Filter
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-list two-line class="overflow-y-auto thin-scrollbar ma-0 pa-0" content-class=" thin-scrollbar">
          <div v-if="layersLoading">
            <v-skeleton-loader  type="list-item-two-line"></v-skeleton-loader>
            <v-divider></v-divider>
            <v-skeleton-loader  type="list-item-two-line"></v-skeleton-loader>
            <v-divider></v-divider>
            <v-skeleton-loader  type="list-item-two-line"></v-skeleton-loader>
          </div>
          <v-list-item-group v-else-if="layers.length > 0"
            v-model="selectedLayers"
            active-class="blue--text"
            multiple
          >
            <template v-for="(item, index) in layers">
              <v-list-item :key="'layer'+index" :disabled="layersLoading || layersUpdating">
                <template v-slot:default="{ active }">
                  <v-list-item-content>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-list-item-title v-bind="attrs" v-on="on" v-text="item.companies_text"></v-list-item-title>
                      </template>
                      <span>{{ item.companies_text }} {{item.amount}} properties</span>
                    </v-tooltip>

                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-list-item-subtitle v-bind="attrs" v-on="on"
                                              v-text="item.filters_text"></v-list-item-subtitle>
                      </template>
                      <span>{{ item.filters_text }}</span>
                    </v-tooltip>
                    <v-list-item-subtitle v-text="item.address_type_text"></v-list-item-subtitle>
                  </v-list-item-content>

                  <v-list-item-action>
                    <div v-if="!active">
                      <span>{{ item.amount }}</span>
                      <v-icon

                        color="grey lighten-1"
                      >
                        mdi-map-marker-check-outline
                      </v-icon>
                      <v-icon @click.stop="removeLayer(index)">
                        mdi-delete
                      </v-icon>
                    </div>
                    <div v-else :title="item.amount + ' properties'">
                      <span>{{ item.amount }}</span>
                      <v-icon

                        color="blue darken-3'"
                      >
                        mdi-map-marker-check-outline
                      </v-icon>

                      <v-icon color="blue darken-3'" @click.stop="removeLayer(index)">
                        mdi-delete
                      </v-icon>
                    </div>


                  </v-list-item-action>
                </template>
              </v-list-item>

              <v-divider
                v-if="index < layers.length - 1"
                :key="index"
              ></v-divider>
            </template>
          </v-list-item-group>
          <div style="height:231px; display: flex; align-items: center;" v-else>
            <v-list-item-title class="text-center grey--text">There are currently no<br/>active filters</v-list-item-title>
          </div>
        </v-list>

      </v-card-text>
    </div>
    
  </div>
</template>

<script>
import EditSchemeDialog from '@/components/schemes/editSchemeDialog'
import MarkerClusterer from 'marker-clusterer-plus';
import DemographicInfoDialog from "../../components/info/demographicInfoDialog";
import EditStandalonePropertyDialog from "@/components/properties/editStandalonePropertyDialog";
import EditPropertyDialog from "@/components/properties/editPropertyDialog";
import addPropertyDialog from '@/components/properties/addPropertyDialog'
import AddSchemeDialog from '@/components/schemes/addSchemeDialog'
import CreateLayerDialog from "@/components/map/createLayerDialog";
import ChargingPointInfoDialog from "@/components/info/chargingPointInfoDialog";
import axios from "axios";
import MapTooltip from "@/components/map/MapTooltip";

import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

import { property } from 'lodash';
import { add } from 'lodash';
import { set } from 'lodash';
// import GoogleAutocomplete from '@/components/common/googleAutocomplete';
export default {
  components: {
    MapTooltip,
    ChargingPointInfoDialog,
    EditStandalonePropertyDialog,
    EditPropertyDialog,
    DemographicInfoDialog,
    EditSchemeDialog,
    CreateLayerDialog,
    // GoogleAutocomplete,

    addPropertyDialog,
    AddSchemeDialog
  },
  data() {
    return {
      // labelStyle: {
      //   fontFamily: 'Roboto, sans-serif',
      //   fontSize: '14px',
      //   fontWeight: '500',
      //   color: '#fff',
      //   textShadow: '0 0 2px #000',
      //   textAlign: 'center',
      //   lineHeight: '1.5',
      //   whiteSpace: 'nowrap',
      //   border: '2px solid #000', // Make sure this line is added
      //   borderRadius: '2px',
      //   padding: '6px 10px',
      // },
      ///
      loading: false,
      exporting: false,
      schemeFilter: null,
      searchMenu: true,
      filterMenu: true,
      // showAllMarkers: true,
      filterRPDMarkers: false,
      // showMarkers: [],
      // groupByScheme: false,
      // demographicsView: false,
      // chargingPointsView: false,
      showCircles: false,
      // googleLabels: false,
      cluster: null,
      schemes: {
        loading: false,
        items: [],
        search: null,
      },

      activeTab: 0,

      place: '',
      placeObject: '',
      markers: [],
      createdMarkers: [],
      createdLayerMarkers: [],
      ignoredMarkerCount: 0,
      createdLayerMarkersCount: 0,
      ignoredLayerMarkersCount: 0,
      allMarkers: [],
      activeMarkers: [],
      layers: [],
      layerMarkers: [],
      layersLoading: false,
      layersUpdating: false,
      demographicsMarkers: [],
      chargingPointsMarkers: [],

      propertyType: null,
      addressLoading: false,
      placingMarker: false,
      propertyMarker: null,
      propertyAddress: {
          line1: '',
          line2: '',
          city: '',
          state: '',
          country: '',
          zip: ''
      },

      markerOptions: {
        url: '/public/img/rpd-marker-w.png',
        scaledSize: {
            width: 18,
            height: 25
        }
      },
      zoom: 6,
      zoomLevel: null,
      center: {lat: 54.57420094589084, lng: -3.6402000000000068},
      mapStyles: [
      {
          featureType: "administrative",
          elementTypefeatureType: "geometry",
          stylers: [
            {
              visibility: "on"
            }
          ]
        },
        {
          featureType: "administrative.neighborhood",
          stylers: [
            {
              visibility: "on"
            }
          ]
        },
        // {
        //   featureType: "landscape.man_made",
        //   elementType: "geometry.fill",
        //   stylers: [
        //     {
        //       color: "#f4f4f5"
        //     },
        //     {
        //       visibility: "on"
        //     },
        //     {
        //       weight: 1
        //     }
        //   ]
        // },
        {
          featureType: "landscape.man_made",
          elementType: "labels.icon",
          stylers: [
            {
              weight: 5
            }
          ]
        },
        {
          featureType: "landscape.natural",
          elementType: "geometry.fill",
          stylers: [
            {
              color: "#dddde4"
            }
          ]
        },
        {
          featureType: "poi",
          stylers: [
            {
              visibility: "on"
            }
          ]
        },
        {
          featureType: "poi",
          elementType: "labels.icon",
          stylers: [
            {
              visibility: "on"
            }
          ]
        },
        {
          featureType: "poi",
          elementType: "geometry.fill",
          stylers: [
            {
              color: "#dad7fe"
            }
          ]
        },
        {
          featureType: "poi",
          elementType: "labels.text",
          stylers: [
            {
              visibility: "off"
            }
          ]
        },
        {
          featureType: "poi.park",
          elementType: "geometry.fill",
          stylers: [
            {
              visibility: "on"
            }
          ]
        },
        {
          featureType: "road.highway",
          elementType: "geometry.fill",
          stylers: [
            {
              color: "#c2c0d3"
            }
          ]
        },
        {
          featureType: "road.highway",
          elementType: "geometry.stroke",
          stylers: [
            {
              color: "#9897af"
            }
          ]
        },
        {
          featureType: "road",
          elementType: "labels",
          stylers: [
            {
              visibility: "on"
            }
          ]
        },
        {
          featureType: "road",
          elementType: "labels.icon",
          stylers: [
            {
              visibility: "on"
            }
          ]
        },
        {
          featureType: "road.arterial",
          elementType: "labels",
          stylers: [
            {
              visibility: "on"
            }
          ]
        },
        {
          featureType: "road.highway",
          elementType: "labels",
          stylers: [
            {
              visibility: "on"
            }
          ]
        },
        {
          featureType: "road.local",
          stylers: [
            {
              visibility: "on"
            }
          ]
        },
        {
          featureType: "road.local",
          elementType: "geometry.fill",
          stylers: [
            {
              color: "#b8b8bf"
            },
            {
              weight: 3
            }
          ]
        },
        {
          featureType: "road.local",
          elementType: "geometry.stroke",
          stylers: [
            {visibility: "on"}
          ]
        },
        {
          featureType: "transit",
          stylers: [
            {
              visibility: "on"
            }
          ]
        },
        {
          featureType: "water",
          elementType: "geometry.fill",
          stylers: [
            {
              color: "#aeb7f9"
            }
          ]
        },
        {
          featureType: "water",
          elementType: "labels.text",
          stylers: [
            {
              visibility: "on"
            }
          ]
        }
        ],
      mapStylesMarkerless: [
        {
          featureType: "administrative",
          elementTypefeatureType: "geometry",
          stylers: [
            {
              visibility: "on"
            }
          ]
        },
        {
          featureType: "administrative.neighborhood",
          stylers: [
            {
              visibility: "on"
            }
          ]
        },
        // {
        //   featureType: "landscape.man_made",
        //   elementType: "geometry.fill",
        //   stylers: [
        //     {
        //       color: "#f4f4f5"
        //     },
        //     {
        //       visibility: "on"
        //     },
        //     {
        //       weight: 1
        //     }
        //   ]
        // },
        {
          featureType: "landscape.man_made",
          elementType: "labels.icon",
          stylers: [
            {
              weight: 5
            }
          ]
        },
        {
          featureType: "landscape.natural",
          elementType: "geometry.fill",
          stylers: [
            {
              color: "#dddde4"
            }
          ]
        },
        {
          featureType: "poi",
          stylers: [
            {
              visibility: "on"
            }
          ]
        },
        {
          featureType: "poi",
          elementType: "labels.icon",
          stylers: [
            {
              visibility: "off"
            }
          ]
        },
        {
          featureType: "poi",
          elementType: "geometry.fill",
          stylers: [
            {
              color: "#dad7fe"
            }
          ]
        },
        {
          featureType: "poi",
          elementType: "labels.text",
          stylers: [
            {
              visibility: "off"
            }
          ]
        },
        {
          featureType: "poi.park",
          elementType: "geometry.fill",
          stylers: [
            {
              visibility: "on"
            }
          ]
        },
        {
          featureType: "road.highway",
          elementType: "geometry.fill",
          stylers: [
            {
              color: "#c2c0d3"
            }
          ]
        },
        {
          featureType: "road.highway",
          elementType: "geometry.stroke",
          stylers: [
            {
              color: "#9897af"
            }
          ]
        },
        {
          featureType: "road",
          elementType: "labels",
          stylers: [
            {
              visibility: "on"
            }
          ]
        },
        {
          featureType: "road",
          elementType: "labels.icon",
          stylers: [
            {
              visibility: "on"
            }
          ]
        },
        {
          featureType: "road.arterial",
          elementType: "labels",
          stylers: [
            {
              visibility: "on"
            }
          ]
        },
        {
          featureType: "road.highway",
          elementType: "labels",
          stylers: [
            {
              visibility: "on"
            }
          ]
        },
        {
          featureType: "road.local",
          stylers: [
            {
              visibility: "on"
            }
          ]
        },
        {
          // weight 4 at zoom 10
          featureType: "road.local",
          elementType: "geometry.fill",
          stylers: [

            {
              color: "#b8b8bf"
            },
            {
              weight: 3
            }
          ]
        },
        {
          featureType: "road.local",
          elementType: "geometry.stroke",
          stylers: [
            {visibility: "off"}
          ]
        },
        {
          featureType: "transit",
          stylers: [
            {
              visibility: "on"
            }
          ]
        },
        {
          featureType: "water",
          elementType: "geometry.fill",
          stylers: [
            {
              color: "#aeb7f9"
            }
          ]
        },
        {
          featureType: "water",
          elementType: "labels.text",
          stylers: [
            {
              visibility: "on"
            }
          ]
        }
        ],
      mapOptions: {
        // styles: [{
        //   featureType: 'poi',
        //   stylers: [{visibility: 'off'}],
        // },{
        //   featureType: "landscape.man_made",
        //   elementType: "geometry.fill",
        //   stylers: [
        //     {
        //       color: "#f4f4f5"
        //     },
        //     {
        //       visibility: "on"
        //     },
        //     {
        //       weight: 1
        //     }
        //   ]
        // },]
        mapTypeId: 'roadmap',
        styles: [
        {
          featureType: "administrative",
          elementTypefeatureType: "geometry",
          stylers: [
            {
              visibility: "on"
            }
          ]
        },
        {
          featureType: "administrative.neighborhood",
          stylers: [
            {
              visibility: "on"
            }
          ]
        },
        // {
        //   featureType: "landscape.man_made",
        //   elementType: "geometry.fill",
        //   stylers: [
        //     {
        //       color: "#f4f4f5"
        //     },
        //     {
        //       visibility: "on"
        //     },
        //     {
        //       weight: 1
        //     }
        //   ]
        // },
        {
          featureType: "landscape.man_made",
          elementType: "labels.icon",
          stylers: [
            {
              weight: 5
            }
          ]
        },
        {
          featureType: "landscape.natural",
          elementType: "geometry.fill",
          stylers: [
            {
              color: "#dddde4"
            }
          ]
        },
        {
          featureType: "poi",
          stylers: [
            {
              visibility: "on"
            }
          ]
        },
        {
          featureType: "poi",
          elementType: "labels.icon",
          stylers: [
            {
              visibility: "off"
            }
          ]
        },
        {
          featureType: "poi",
          elementType: "geometry.fill",
          stylers: [
            {
              color: "#dad7fe"
            }
          ]
        },
        {
          featureType: "poi",
          elementType: "labels.text",
          stylers: [
            {
              visibility: "off"
            }
          ]
        },
        {
          featureType: "poi.park",
          elementType: "geometry.fill",
          stylers: [
            {
              visibility: "on"
            }
          ]
        },
        {
          featureType: "road.highway",
          elementType: "geometry.fill",
          stylers: [
            {
              color: "#c2c0d3"
            }
          ]
        },
        {
          featureType: "road.highway",
          elementType: "geometry.stroke",
          stylers: [
            {
              color: "#9897af"
            }
          ]
        },
        {
          featureType: "road",
          elementType: "labels",
          stylers: [
            {
              visibility: "on"
            }
          ]
        },
        {
          featureType: "road",
          elementType: "labels.icon",
          stylers: [
            {
              visibility: "on"
            }
          ]
        },
        {
          featureType: "road.arterial",
          elementType: "labels",
          stylers: [
            {
              visibility: "on"
            }
          ]
        },
        {
          featureType: "road.highway",
          elementType: "labels",
          stylers: [
            {
              visibility: "on"
            }
          ]
        },
        {
          featureType: "road.local",
          stylers: [
            {
              visibility: "on"
            }
          ]
        },
        {
          // weight 4 at zoom 10
          featureType: "road.local",
          elementType: "geometry.fill",
          stylers: [

            {
              color: "#b8b8bf"
            },
            {
              weight: 3
            }
          ]
        },
        {
          featureType: "road.local",
          elementType: "geometry.stroke",
          stylers: [
            {visibility: "off"}
          ]
        },
        {
          featureType: "transit",
          stylers: [
            {
              visibility: "on"
            }
          ]
        },
        {
          featureType: "water",
          elementType: "geometry.fill",
          stylers: [
            {
              color: "#aeb7f9"
            }
          ]
        },
        {
          featureType: "water",
          elementType: "labels.text",
          stylers: [
            {
              visibility: "on"
            }
          ]
        }
        ],
        // remove zoom controls
        // ignore_no_size: false
        zoomControlOptions: {},
        streetViewControlOptions: {},
        circle1InfoWindowOpened: true,
        circle2InfoWindowOpened: true,
      },
      selectedLayers: [],


    }
  },
  mounted() {

    this.$gmapApiPromiseLazy().then(() => {
      let _self = this;
      this.cluster = new MarkerClusterer(this.$refs.map.$mapObject, [], {
        imagePath: 'https://raw.githubusercontent.com/googlemaps/v3-utility-library/bd55f49fc8492207d30e179d280c00aa8b5016e0/markerclusterer/images/m'
      });

      this.mapOptions.zoomControlOptions = {
        position: google.maps.ControlPosition.LEFT_BOTTOM
      };
      this.mapOptions.streetViewControlOptions = {
        position: google.maps.ControlPosition.LEFT_BOTTOM
      };
      // fullscreen top left
      this.mapOptions.fullscreenControlOptions = {
        position: google.maps.ControlPosition.RIGHT_BOTTOM
      };

      if (this.$store.state.map.satellite) {
        this.mapOptions.mapTypeId = this.$store.state.map.satellite
      }else{
        // satellite
        this.mapOptions.mapTypeId = 'hybrid'
      }
      
      // autocomplete ref, set country to UK
      // this.$refs.autocompleteRef.$autocompleteObject.setComponentRestrictions({
      //   country: ['gb']
      // });

      google.maps.event.addListener(this.$refs.map.$mapObject, 'idle', function () {
        // if(_self.$refs.map.$mapObject.getZoom() < 15) {
        //     _self.clearAllMarkers();
        //     return false;
        // }
        _self.updateMap();
        // console.log(_self.$refs.map.$mapObject.getZoom())
      });

      // listener for satellite view change
      google.maps.event.addListener(this.$refs.map.$mapObject, 'maptypeid_changed', function () {
        _self.$store.commit('updateMapSatellite', _self.$refs.map.$mapObject.getMapTypeId())
      });

      // google.maps.event.addListener(this.$refs.map.$mapObject,'mouseover',function(){
      //     this.getMap().getDiv().setAttribute('title',this.get('title'));
      // });
      //
      // google.maps.event.addListener(this.$refs.map.$mapObject,'mouseout',function(){
      //     this.getMap().getDiv().removeAttribute('title');
      // });
      // this.cluster.addListener('clusterclick', function(cluster) {
      // 	// your code here
      //    console.log(cluster)
      //    console.log(cluster.getMarkers())
      // });
      // this.getAllDataPaginated()
      this.initMapFilters();
      // this.getAllData()

      // if (localStorage.getItem('map.groupByScheme')) {
      //   try {
      //     this.groupByScheme = JSON.parse(localStorage.getItem('map.groupByScheme'));
      //   } catch(e) {
      //     localStorage.removeItem('map.groupByScheme');
      //   }
      // }
    });
    // this.$refs.circleRef1.$circlePromise.then(() => {
    //     const {$circleObject} = this.$refs.circleRef; //get google.maps.Circle object
    //     console.log($circleObject)
    // })


    if (this.$route.params.scheme) {
      this.schemeFilter = this.$route.params.scheme.id;
      this.schemes.items.push(this.$route.params.scheme)
    }

    // if(this.$route.params.tenant) {
    // 	//todo add layer
    // 	this.tenantFilter = this.$route.params.tenant.id;
    // 	this.tenants.items.push(this.$route.params.tenant)
    // }
  },
  watch: {
    'showMarkers'(value) {
      if(value == null){
        this.showMarkers = []
      }
      //todo state
      this.clearAllMarkers();
      this.updateMap();
    },

    'schemes.search'() {
      this.debounce(() => {
        this.getSchemes()
      }, 375);
    },
    // showAllMarkers(val) {
    //   //todo state
    //   this.clearAllMarkers();
    //   this.updateMap();
    // },
    // groupByScheme(val) {
    //   // localStorage.setItem('map.groupByScheme', val)
    //   //todo state
    //   this.clearAllMarkers();
    //   this.updateMap();
    // },
    // googleLabels(val) {
    //   //todo state
    //   if (val) {
    //     this.changeLabelsVisibility('on')
    //   } else {
    //     this.changeLabelsVisibility('off')
    //   }
    // },
    selectedLayers(val, oldVal) {

      this.toggleLayer(val, oldVal);
    },
    // demographicsView(value) {
    //   //todo state
    //   if (value) {
    //     this.getDemographics()
    //   } else {
    //     for (let m of this.demographicsMarkers) {
    //       m.setMap(null)
    //     }
    //   }
    // },
    // chargingPointsView(value) {
    //   //todo state
    //   if (value) {
    //     this.getChargingPointsPaginated()
    //   } else {
    //     for (let m of this.chargingPointsMarkers) {
    //       m.setMap(null)
    //     }
    //   }
    // },
    // activeMarkers(newMarkers) {
    // 	this.cluster.clearMarkers();
    // 	let markers = newMarkers.map(item => this.createMarker(item));
    // 	this.cluster.addMarkers(markers);
    //
    // 	const bounds = new google.maps.LatLngBounds()
    // 	for (let m of newMarkers) {
    // 		bounds.extend(m.position)
    // 	}
    // 	if(newMarkers.length >= 1) {
    // 		this.$refs.map.fitBounds(bounds)
    //     }
    // 	if(newMarkers.length === 1) {
    // 		this.$refs.map.$mapObject.setZoom( 16 );
    // 	}
    // }
  },
  beforeDestroy() {
    this.clearAllMarkers();
    for (let m of this.demographicsMarkers) {
      m.setMap(null)
    }
    for (let m of this.chargingPointsMarkers) {
      m.setMap(null)
    }
    for (let m of this.layerMarkers) {
      m.setMap(null)
    }
    this.cluster = null;

    google.maps.event.clearListeners(this.$refs.map.$mapObject);
    google.maps.event.clearInstanceListeners(this.$refs.map.$mapObject);
    this.allMarkers = [];
    this.layerMarkers = [];
    this.demographicsMarkers = [];
    this.chargingPointsMarkers = [];
    this.$refs.map.$mapObject = null;
    this.$refs.map = null;

  },
  computed: {

    RPDFilterActive() {
      return this.showMarkers.length < 4 && this.showAllMarkers;
    },

    searchLocation() {
      if (this.placeObject) {
        return this.placeObject.geometry.location;
      }

      if (this.schemeFilter) {
        let schemeAddresses = this.allMarkers.filter(item => {
          return item.entity_type === 'scheme' && item.entity_id === this.schemeFilter;
        });
        if (schemeAddresses.length) {
          return schemeAddresses[0].position;
        }
      }
      return false;
    },

    validAddress(){
        // return this.propertyAddress.line1 && this.propertyAddress.city && this.propertyAddress.state && this.propertyAddress.zip;
        return this.propertyAddress.line1 || this.propertyAddress.city || this.propertyAddress.state
    },

    compiledAddress(){
      let address = '';
      if(this.propertyAddress.city) {
        address += this.propertyAddress.city + ', ';
      }
      if (this.propertyAddress.state && this.propertyAddress.zip) {
        address += this.propertyAddress.state + ' ' + this.propertyAddress.zip + ', ';
        
      }else if(this.propertyAddress.state) {
        address += this.propertyAddress.state + ', ';
      }else if (this.propertyAddress.zip) {
        address += this.propertyAddress.zip + ', ';
      }
      if(this.propertyAddress.country) {
        address += this.propertyAddress.country;
      }

      return address;
    },


    showMarkers:{
      get () {
        return this.$store.state.map.filters.showMarkers
      },
      set (value) {
        this.$store.commit('updateMapFilters', {key: 'showMarkers', value: value})
        this.clearAllMarkers();
        this.updateMap();
      }
    },

    groupByScheme: {
      get () {
        return this.$store.state.map.filters.groupByScheme
      },
      set (value) {
        this.$store.commit('updateMapFilters', {key: 'groupByScheme', value: value})
        this.clearAllMarkers();
        this.updateMap();
      }
    },

    showAllMarkers: {
      get () {
        return this.$store.state.map.filters.showAllMarkers
      },
      set (value) {
        this.$store.commit('updateMapFilters', {key: 'showAllMarkers', value: value})
        this.clearAllMarkers();
        this.updateMap();
      }
    },

    googleLabels: {
      get () {
        this.changeLabelsVisibility(this.$store.state.map.filters.googleLabels)
        return this.$store.state.map.filters.googleLabels
      },
      set (value) {
        // console.log('mapOptions', this.mapOptions)
        this.changeLabelsVisibility(value)
        this.$store.commit('updateMapFilters', {key: 'googleLabels', value: value})
      }
    },

    demographicsView: {
      get () {
        return this.$store.state.map.filters.demographicsView
      },
      set (value) {
        this.$store.commit('updateMapFilters', {key: 'demographicsView', value: value})
        if (value) {
          this.getDemographics()
        } else {
          for (let m of this.demographicsMarkers) {
            m.setMap(null)
          }
        }
      }
    },

    chargingPointsView: {
      get () {
        return this.$store.state.map.filters.chargingPointsView
      },
      set (value) {
        this.$store.commit('updateMapFilters', {key: 'chargingPointsView', value: value})
        if (value) {
          this.getChargingPointsPaginated()
        } else {
          for (let m of this.chargingPointsMarkers) {
            m.setMap(null)
          }
        }
      }
    },

    drawer: {
      get () {
        return this.$store.state.map.drawer
      },
      set (value) {
        this.$store.commit('updateMapDrawer', value)
      }
    }

    // storageLayers: {
    //   get () {
    //     return this.$store.state.map.layers
    //   }
    // },

  },
  methods: {
    async exportPDF(){
      this.exporting = true;
      // prompt user to title the PDF
      const title = prompt('Enter a title for the exported document', 'RPD Export');
      if (!title) {
        this.exporting = false;
        return; // user cancelled
      }

      let mapElement = this.$refs.map.$mapObject.getDiv();
      mapElement.classList.add('hide-map-controls');
      await this.$nextTick();
      const mapCanvas = await html2canvas(mapElement, {
        useCORS: true,
        allowTaint: true,
        scale: 2
      });
      const mapData = mapCanvas.toDataURL('image/png');
      

      const pdf = new jsPDF({
        orientation: 'landscape',
        unit: 'mm',
        format: 'a4'
      });
      const imgProps = pdf.getImageProperties(mapData);
      const imgWidth = imgProps.width;
      const imgHeight = imgProps.height;
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const margin = 10;
      const headerHeight = 15;
      const mapY = headerHeight + margin;
      const mapMaxWidth = pdfWidth - 2 * margin;
      const mapMaxHeight = pdfHeight - mapY - margin;

      // Draw light grey background rectangle
      pdf.setFillColor(240); // light grey
      pdf.rect(0, 0, pdfWidth, headerHeight, 'F'); // F = filled rectangle

      let logo = new Image();
      logo.src = process.env.VUE_APP_BACKEND_BASE + 'img/logos/rpd2_logo.png';

      // add logo to the left side of the header
      pdf.addImage(logo, 'PNG', -5, 2, 40, 10); // x, y, width, height

      // Set font
      pdf.setFont('helvetica');
      pdf.setFontSize(28);
      pdf.setTextColor(59,63,61);
      pdf.text(title, 30, 10.5);

      pdf.setTextColor(120,120,120);
      pdf.setFontSize(12);
      // Add date (right side)
      const dateText = new Date().toLocaleDateString()
      const dateWidth = pdf.getTextWidth(dateText);
      pdf.text(dateText, pdfWidth - dateWidth - 2, 5);

      const imgAspect = imgWidth / imgHeight;
      const boxAspect = mapMaxWidth / mapMaxHeight;

      let drawWidth, drawHeight;

      if (imgAspect > boxAspect) {
        // Image is wider than the box — scale to width, crop height
        drawWidth = mapMaxWidth;
        drawHeight = drawWidth / imgAspect;
      } else {
        // Image is taller than the box — scale to height, crop width
        drawHeight = mapMaxHeight;
        drawWidth = drawHeight * imgAspect;
      }

      const drawX = margin + (mapMaxWidth - drawWidth) / 2;
      const drawY = mapY + (mapMaxHeight - drawHeight) / 2;

      pdf.addImage(mapData, 'PNG', drawX, drawY, drawWidth, drawHeight);

      let offset = pdfHeight + 20; // offset for table below the map
      // get all markers inside the current bounds, regardless of marker limit

      let tableData = this.allMarkers.filter(item => {
        return item.position && this.$refs.map.$mapObject.getBounds().contains(item.position);
      })
 

      // ID, full, scheme,  tenant, lat, lng
      const tableHeaders = [
        // {title: 'ID', dataKey: 'entity_id'},
        // {title: 'Full Address', dataKey: 'full_address'},
        // {title: 'Scheme', dataKey: 'scheme_name'},
        // {title: 'Tenant', dataKey: 'tenant_name'},
        // {title: 'Latitude', dataKey: 'position.lat'},
        // {title: 'Longitude', dataKey: 'position.lng'}
        'Scheme',
        'Tenant',
        'Address',
      ]

      const tableRows = tableData.map(item => {
        return [
          item.scheme_name || 'N/A',
          item.tenant_name || 'N/A',
          item.full_address || 'N/A'
        ]
      });

      autoTable(pdf, {
        head: [tableHeaders],
        body: tableRows,
        startY: offset,
        margin: {top: 10, left: 10, right: 10},
        styles: {
          fontSize: 10,
          cellPadding: 2,
          overflow: 'linebreak',
          halign: 'left',
          valign: 'middle'
        },
        headStyles: {
          fillColor: [138,125,190],   // light grey background
        },
        columnStyles: {
          entity_id: {cellWidth: 20},
          full_address: {cellWidth: 80},
          scheme_name: {cellWidth: 30},
          tenant_name: {cellWidth: 30},
          'position.lat': {cellWidth: 20},
          'position.lng': {cellWidth: 20}
        }
      });
      pdf.save(`${title}.pdf`);
      mapElement.classList.remove('hide-map-controls');
      this.exporting = false;
    },


    async initMapFilters() {
      // if(this.googleLabels) {
      //   this.changeLabelsVisibility('on')
      // }
      if(this.demographicsView) {
        await this.getDemographics()
      }
      if(this.chargingPointsView) {
        await this.getChargingPointsPaginated()
      }
      // if(this.storageLayers.length) {
      //   await this.initLayerMarkers()
      // }
      this.initLayerMarkers()
    },
    changeLabelsVisibility(visibility) {
      // this.mapOptions.styles = [{
      //   featureType: 'poi',
      //   stylers: [{visibility: visibility}],
      // }];
      this.mapOptions.styles = visibility === true ? this.mapStyles : this.mapStylesMarkerless;
    },
    updateSchemeMarker(data) {
      // data.id, data.position
      // console.log(id, position)
      let schemeIndex = this.allMarkers.findIndex((item) => {
        return item.entity_id === data.id && item.entity_type === 'scheme'
      })
      if (schemeIndex !== -1) {
        this.allMarkers[schemeIndex].position = data.position;
        this.clearAllMarkers();
        this.updateMap();
      }
    },
    deleteSchemeMarker(data) {
      // data.id
      // let schemeIndex = this.allMarkers.findIndex((item) => {
      //   return item.entity_id === data.id && item.entity_type === 'scheme'
      // })
      // if (schemeIndex !== -1) {
      //   this.allMarkers.splice(schemeIndex, 1)

      this.allMarkers = this.allMarkers.filter(item => item.scheme_id !== data.id);

      this.clearAllMarkers();
      this.updateMap();
    },

    deletePropertyMarker(data) {
      // data.id
      this.allMarkers = this.allMarkers.filter(item => item.entity_id !== data.id || item.entity_type === 'scheme');

      this.clearAllMarkers();
      this.updateMap();
    },

    updatePropertyMarker(data) {
      let addressUpdated = false;

      let propertyIndex = this.allMarkers.findIndex((item) => {
        return item.entity_id === data.id && item.entity_type === 'property'
      })
      if (propertyIndex !== -1) {
        this.allMarkers[propertyIndex].position = data.position;
        addressUpdated = true;
      }
      this.layers.forEach((layer, index) => {
        let propertyIndex = layer.markers.findIndex((item) => {
          return item.entity_id === data.id
        })
        if (propertyIndex !== -1) {
          layer.markers[propertyIndex].position = data.position;
          addressUpdated = true;
        }
      });
      if (addressUpdated) {
        this.clearAllMarkers();
        this.updateMap();
      }
    },
    addLayer(layer) {
      this.layers.push(layer)
      // this.selectedLayers = 0;
      let storageLayer = {...layer}
      storageLayer.markers = [];

      this.$store.commit('addMapLayer', storageLayer)
      this.getLayerMarkers();

      // if (this.layers.length === 1) {
      //   // this.showAllMarkers = false;
      //   this.$store.commit('updateMapFilters', {key: 'showAllMarkers', value: false})
      // }

      // this.updateMap();
    },

    async toggleLayer(val, oldVal) {
      this.layersUpdating = true;
      let changedLayer = {
        index: null,
        // value is true if layer is added, false if removed
        value: null
      }
      // check if a layer has been added or removed, and what layer it is
      for (let i = 0; i < val.length; i++) {
        if (oldVal.indexOf(val[i]) === -1) {
          changedLayer.index = val[i];
          changedLayer.value = true;
          break;
        }
      }
      if (changedLayer.index === null) {
        for (let i = 0; i < oldVal.length; i++) {
          if (val.indexOf(oldVal[i]) === -1) {
            changedLayer.index = oldVal[i];
            changedLayer.value = false;
            break;
          }
        }
      }

      let {index, value} = changedLayer;

      // get the layer from the store
      if (index === null) {
        this.layersUpdating = false;
        return;
      }
      let layer = this.layers[index];
      if (!layer) {
        this.layersUpdating = false;
        return;
      }
      if(value) {
        // set map cursor to loading
        console.log(this.$refs.map.$mapObject)
        this.$refs.map.$mapObject.setOptions({draggableCursor: 'wait'});
        await this.$http.get('/map/layer/coordinates', {
          params: layer.params
        }).then((response) => {
          this.layers[index].markers = response.data.data;

          // check if the amount of markers is different to the saved value, if so, update the layer
          if (this.layers[index].amount !== response.data.data.length) {
            this.layers[index].amount = response.data.data.length;
            let storageLayer = {...this.layers[index]}
            storageLayer.markers = [];
            this.$store.commit('updateMapLayer', {index, layer: storageLayer})
          }
          this.$refs.map.$mapObject.setOptions({draggableCursor: ''});
          this.getLayerMarkers();
          // this.$store.commit('updateMapLayer', {index, layer: layer})
        });
      } else {
        this.layersUpdating = false;
        this.$refs.map.$mapObject.setOptions({draggableCursor: ''});
        this.getLayerMarkers();
        // remove layer markers
        // this.layers[index].markers = [];
        // this.$store.commit('updateMapLayer', {index, layer: layer})
      }


    },

    removeLayer(index) {

      this.$store.commit('removeMapLayer', index)
      this.layers.splice(index, 1)
      // sort selected layers. if removed layer was before selected layer, decrease selected layer index, if it was the selected layer, remove it
      this.selectedLayers = this.selectedLayers.map((item) => {
        if (item > index) {
          return item - 1;
        }
        else if (item === index) {
          return null;
        }
        return item;
      }).filter((item) => item !== null);
      this.getLayerMarkers();
    },

    updateMap() {
      let bounds = this.$refs.map.$mapObject.getBounds();
      let zoom = this.$refs.map.$mapObject.getZoom();
      this.zoomLevel = zoom;
      // break if zoom is less than 15
      if (zoom < 10) {
        this.clearAllMarkers();
        return false;
      }

      // make map coordinates request with sw_lat, sw_lng, ne_lat, ne_lng
      this.$http.get('/map/coordinates', {
        params: {
          
          sw_lat: bounds.getSouthWest().lat(),
          sw_lng: bounds.getSouthWest().lng(),
          ne_lat: bounds.getNorthEast().lat(),
          ne_lng: bounds.getNorthEast().lng(),
          group_by_scheme: this.groupByScheme ? true : 0,
          types: this.showMarkers,
          
        }
      }).then((response) => {
        this.populateMarkers(response.data.data);
      });

      
      
    },

    async populateMarkers(markers) {
      const zoom = this.$refs.map.$mapObject.getZoom();
      const bounds = this.$refs.map.$mapObject.getBounds();

      this.ignoredMarkerCount = 0;
      this.ignoredLayerMarkersCount = 0;
      this.createdLayerMarkersCount = 0;

      this.clearHiddenMarkers();

      if (!this.showAllMarkers) return;

      const showShops = this.showMarkers.includes('Shops');
      const isGrouped = this.groupByScheme;

      const markerSet = new Set(
        this.createdMarkers.map(m => `${m.position.lat()},${m.position.lng()}`)
      );

      // // if groupByScheme is true, filter markers to only include schemes or standalone properties
      // if (isGrouped) {
      //   markers = markers.filter(item => item.entity_type === 'scheme' || (item.entity_type === 'property' && !item.scheme_id));
      // }else {
      //   // hide schemes
      //   markers = markers.filter(item => item.entity_type !== 'scheme' );
      // }

      markers.forEach(item => {
        this.createMarker(item, false, bounds, zoom, markerSet);
      });
    },

    async initLayerMarkers() {
      this.layersLoading = true;
      this.layers = [...this.$store.state.map.layers];
      this.layersLoading = false;
    },

    getLayerMarkers() {
      if (this.layerMarkers.length) {
        this.layerMarkers.forEach((marker) => {
          marker.setMap(null);
        });
      }
      this.layerMarkers = [];
      let markers = [];
      let layers = this.layers.filter((layer, index) => {
        return this.selectedLayers.includes(index);
      });
      // layers.forEach((layer) =>{
      //   // filter out duplicate entity_id markers and merge them
      //   let layerMarkers = layer.markers.filter((item) => {
      //     return !markers.some((marker) => {
      //       return marker.entity_id === item.entity_id
      //     });
      //   });
      //   markers.push(...layerMarkers);
      // })
      markers = this.filterDuplicates(layers);
      for (let m of markers){
        this.createLayerMarker(m).setMap(this.$refs.map.$mapObject);
      }
      this.layersUpdating = false;
    },

    filterDuplicates(layers){
      let markersMap = new Map();

      layers.forEach(layer => {
        layer.markers.forEach(marker => {
          if (!markersMap.has(marker.entity_id)) {
            markersMap.set(marker.entity_id, marker);
          }
        });
      });

      let markers = Array.from(markersMap.values());
      return markers;

    },

    createLayerMarker(item){
      let markerData = {
        position: item.position,
          title: item.full_address,
          map: this.$refs.map.$mapObject,
          icon: {
            url: process.env.VUE_APP_BACKEND_BASE + 'img/rpd-marker-p.png',
            scaledSize: new google.maps.Size(28.125, 36),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(14.05, 36),
            labelOrigin: new google.maps.Point(14.0625, 44),
          },
      }
      if(item.logo) {
        // markerData.icon = {url: process.env.VUE_APP_BACKEND_BASE + item.logo, size: new google.maps.Size(40, 40),};
        markerData.icon = {

          url: 'https://rpd-public-' + (process.env.VUE_APP_ENV == 'production' ? 'files' : 'dev') + '.s3.eu-west-2.amazonaws.com/logos/' + item.logo,
        }
      }

      let marker = new google.maps.Marker(markerData);


      marker.addListener('click', () => {
        this.showEditModal(item);
      });

      this.layerMarkers.push(marker);
      return marker;
    },

    //todo optimise
    getActiveMarkers() {
      let allMarkers = [];
      // this.layers.forEach((layer, index) => {
      //   if (this.selectedLayers.includes(index)) {
      //     allMarkers.push(...layer.markers)
      //   }
      // });
      if (this.showAllMarkers) {
        allMarkers.push(...this.allMarkers)
      }
      return allMarkers;
    },
    filterByBounds() {

    },
    changePlace(place) {
      if (place.geometry) {
        this.$refs.map.fitBounds(place.geometry.viewport);
        setTimeout(() => {
          // get zoom level
          let zoom = this.$refs.map.$mapObject.getZoom();
          if (zoom > 15) {
            this.$refs.map.$mapObject.setZoom(15);
          }
        }, 5);
        this.placeObject = place;
        //todo radius
        this.resetSchemeSearch();
      } else {
        this.fitActiveMarkersBounds();
      }
    },
    changePlaceByScheme(schemeId) {
      if (schemeId) {
        let schemeAddresses = this.allMarkers.filter(item => {
          return item.entity_type === 'scheme' && item.entity_id === schemeId;
        });
        let schemePropertyAddresses = this.allMarkers.filter(item => {
          return item.entity_type === 'property' && item.scheme_id === schemeId;
        });
        let addresses = schemeAddresses.concat(schemePropertyAddresses);
        if (addresses.length) {
          const bounds = new google.maps.LatLngBounds()
          // bounds.extend(addresses[0].position)
          addresses.forEach(address => {
            bounds.extend(address.position);
          });
          this.$refs.map.fitBounds(bounds)
          setTimeout(() => {
          // get zoom level
          let zoom = this.$refs.map.$mapObject.getZoom();
          if (zoom > 18) {
            this.$refs.map.$mapObject.setZoom(18);
          }
        }, 5);
          this.resetPlaceSearch();
        }
      } else {
        // this.fitActiveMarkersBounds();
      }
    },
    createMarker(item, ignoreZoom, bounds, zoom, markerSet) {
      if (zoom < 10 && !ignoreZoom) return;
      const latlng = new google.maps.LatLng(item.position);

      if (!bounds.contains(latlng)) return;

      const key = `${item.position.lat},${item.position.lng}`;
      if (markerSet.has(key)) return;

      if (this.createdMarkers.length > 250 && !ignoreZoom) {
        this.ignoredMarkerCount++;
        return;
      }


      let markerData = {};
      if (item.entity_type === 'scheme') {
        // console.log(item)
        const text = item.scheme_name + ' (' + item.scheme_properties_count + ')';
        markerData = {
          position: item.position,
          title: item.full_address,
          map: this.$refs.map.$mapObject,
          icon: {
            url: process.env.VUE_APP_BACKEND_BASE + 'img/rpd-marker-w.png',
            scaledSize: new google.maps.Size(28.125, 36),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(14.05, 36),
            labelOrigin: new google.maps.Point(14.0625, 44),
          },
          zIndex: 99999999,
          label: {color: 'white', fontWeight: 'bold', fontSize: '13px', text: text, className: "labels"},

        }
      }

      if (item.entity_type === 'property') {
        let text = item.tenant_name ? item.tenant_name : 'Vacant';
        let iconPath = 'img/rpd-marker-p.png';
        if(item.tenant_name){
          text = item.tenant_name;
        }else{
          text = 'Vacant';
          iconPath = 'img/rpd-marker-gray.png';
        }
        markerData = {
          position: item.position,
          title: item.full_address,
          map: this.$refs.map.$mapObject,
          icon: {
            url: process.env.VUE_APP_BACKEND_BASE + iconPath,
            scaledSize: new google.maps.Size(28.125, 36),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(14.05, 36),
            labelOrigin: new google.maps.Point(14.0625, 44),
          },
        }
       
        if(item.logo) {
          // markerData.icon = {url: process.env.VUE_APP_BACKEND_BASE + item.logo, size: new google.maps.Size(40, 40),};
           console.log('item logo url', 'https://rpd-public-' + (process.env.VUE_APP_ENV == 'production' ? 'files' : 'dev') + '.s3.eu-west-2.amazonaws.com/logos/' + item.logo)
          markerData.icon = {
            url: 'https://rpd-public-' + (process.env.VUE_APP_ENV == 'production' ? 'files' : 'dev') + '.s3.eu-west-2.amazonaws.com/logos/' + item.logo,
          }
        }else{
          // limit labels to show up at zoom level 15
          // if(zoom >= 15) {
            markerData.label = {color: 'white', fontWeight: 'bold', fontSize: '13px', text: text, className: "labels"};
          // }
        }
      }
      if(!markerData.position) {
      }

      let marker = new google.maps.Marker(markerData);
      marker.addListener('click', () => {
        this.showEditModal(item);
      });


      this.createdMarkers.push(marker);

      return marker;

      // let markerData = {
      //   position: item.position,
      //   title: item.full_address,
      //   map: this.$refs.map.$mapObject,
      //   // label: {color: 'white', fontWeight: 'bold', fontSize: '14px', text: item.entity_text, className: "labels"},
      //   // label: {
      //   //   text: item.full_address,
      //   //   fontFamily: this.labelStyle.fontFamily,
      //   //   fontSize: this.labelStyle.fontSize,
      //   //   fontWeight: this.labelStyle.fontWeight,
      //   //   color: this.labelStyle.color,
      //   //   textShadow: this.labelStyle.textShadow,
      //   //   textAlign: this.labelStyle.textAlign,
      //   //   lineHeight: this.labelStyle.lineHeight,
      //   //   whiteSpace: this.labelStyle.whiteSpace,
      //   //   border: this.labelStyle.border, // Make sure this line is added
      //   //   borderRadius: this.labelStyle.borderRadius,
      //   //   padding: this.labelStyle.padding,
      //   // },
      //   // label: {
      //   //   text: "5409 Madison St",
      //   //   // color: "#fff",
      //   //   // fontWeight: "bold"
      //   //   fontSize: '20',
      //   //   align: 'right',
      //   // }
      // };
      // let schemeMarkerData = {
      //   position: item.position,
      //   title: item.entity_text,
      //   map: this.$refs.map.$mapObject,
      //   label: {color: 'white', fontWeight: 'bold', fontSize: '14px', text: item.entity_text, className: "labels"}
      // };

      // let marker = new google.maps.Marker(markerData);
      // if (item.entity_type === 'scheme') {
      //   let icon = {
      //     url: "http://maps.google.com/mapfiles/kml/paddle/ylw-circle.png",
      //     // labelOrigin: new google.maps.Point(3, 6)
      //   };//labelOrigin: new google.maps.Point(3, 6)
      //   // marker.setLabel({color: 'white', fontWeight: 'bold', fontSize: '14px', text: item.entity_text, className: "labels"});
      //   //example
      //   // icon: {
      //   //   url: "http://maps.google.com/mapfiles/ms/icons/red-dot.png",
      //   //     labelOrigin: new google.maps.Point(75, 32),
      //   //     size: new google.maps.Size(32,32),
      //   //     anchor: new google.maps.Point(16,32)
      //   // },
      //   // label: {
      //   //   text: "5409 Madison St",
      //   //     color: "#C70E20",
      //   //     fontWeight: "bold"
      //   // }
      //   marker.setIcon(icon);
      //   // marker.setLabel({text:item.entity_text, color: 'white', fontWeight: "bold"});
      // }

      // if (item.entity_type === 'property' && item.logo) {
      //
      //   const image = {
      //     url: process.env.VUE_APP_BACKEND_BASE + item.logo,
      //     size: new google.maps.Size(40, 40),
      //   };
      //   marker.setIcon(image);
      //   // console.log(marker)
      // }

      // marker.addListener('click', () => {
      //   this.showEditModal(item);
      // });
      // marker.addListener('mouseover', (event) => {
      //   if (event && event.pixel) {
      //     console.log('mouseover', event)
      //     const delay = 500; // 500 milliseconds delay
      //     let timer = null;
      //     timer = setTimeout(() => {
      //       this.$refs.tooltip.show(item.id, delay, { x: event.domEvent.clientX, y: event.domEvent.clientY });
      //     }, delay);
      //
      //     marker.addListener('mouseout', () => {
      //       clearTimeout(timer);
      //       this.$refs.tooltip.hide();
      //       console.log('mouseout', item.id)
      //     });
      //   }
      // });

      // this.createdMarkers.push(marker);
      //
      // return marker;
    },
    clearHiddenMarkers() {
      let bounds =  this.$refs.map.$mapObject.getBounds();
      let zoom =  this.$refs.map.$mapObject.getZoom();
      let visible = []
      for (let m of this.createdMarkers) {
        if (!bounds.contains(m.position) || zoom < 10) {
          m.setMap(null)
        } else {
          visible.push(m)
        }
      }
      this.createdMarkers = visible;
    },
    clearAllMarkers() {
      for (let m of this.createdMarkers) {
        // google.maps.event.clearInstanceListeners(m)
        m.setMap(null)
      }
      this.createdMarkers = [];
    },
    createDemographicsMarker(item) {
      let marker = new google.maps.Marker({
        position: item.position,
        title: item.district_sc,
        map: this.$refs.map.$mapObject,
        icon: {
          url: process.env.VUE_APP_BACKEND_BASE + 'img/rpdmarker-red.png',
          scaledSize: new google.maps.Size(25, 32),
          origin: new google.maps.Point(0, 0),
          anchor: new google.maps.Point(12.5, 32),
        },


      });

      marker.addListener('click', () => {
        this.$refs.demographicInfoDialog.showDialog(item.id)
      });

      return marker;
    },
    createChargingPointsMarker(item) {
      let marker = new google.maps.Marker({
        position: item.position,
        title: item.name,
        map: this.$refs.map.$mapObject,
        icon: {
          url: process.env.VUE_APP_BACKEND_BASE + 'img/rpdmarker-green.png',
          scaledSize: new google.maps.Size(25, 32),
          origin: new google.maps.Point(0, 0),
          anchor: new google.maps.Point(12.5, 32),
        },
      });

      marker.addListener('click', () => {
        this.$refs.chargingPointInfoDialog.showDialog(item.id)
      });

      return marker;
    },
    async getAllDataPaginated() {
      this.loading = true;

      this.$refs.map.$mapObject.setOptions({draggableCursor: 'wait'});
      const schemesResponse = await this.$http.get('/map/coordinates', {
        params: {
          entity_type: 'scheme',
        }
      });
      this.allMarkers = schemesResponse.data.data

      const response = await this.$http.get('/map/coordinates');
      this.allMarkers = this.allMarkers.concat(response.data.data);

      let meta = response.data.meta.pagination;
      if (meta.total_pages > 1) {
        for (let i = 2; i <= meta.total_pages; i++) {
          const chunkResponse = await this.$http.get('/map/coordinates', {
            params: {
              page: i,
            }
          });
          this.allMarkers = this.allMarkers.concat(chunkResponse.data.data);
          // rerun markers creation
          this.updateMap();
        }
      }

      if (this.schemeFilter) {
        this.changePlaceByScheme(this.schemeFilter)
      }
      //select scheme
      this.$refs.map.$mapObject.setOptions({draggableCursor: ''});
      this.loading = false;
      // this.updateMap();

    },
    async getBoundsData() {
      this.loading = true;
      const response = await this.$http.get('/map/coordinates');
      this.allMarkers = response.data.data
      this.loading = false;
      this.updateMap();

    },
    async getAllData() {
      this.loading = true;
      await this.$http.get('/map/coordinates', {
        params: {}
      }).then(response => {
        if (response.data.data.length === 0) {
          this.zoom = 5;
        }
        this.allMarkers = response.data.data
        // this.activeMarkers = this.allMarkers.concat(this.allMarkers)
        this.loading = false;
        this.updateMap();
      })
    },
    async getData() {
      this.loading = true;
      await this.$http.get('/map/coordinates', {
        params: {
          // q: this.search,
          scheme_id: this.schemeFilter,
          // type: this.typeFilter,
          // landlord_id: this.landlordFilter,
          // landlord_agent_id: this.landlordAgentFilter,
          // tenant_id: this.tenantFilter,
          // size_min: this.range[0],
          // size_max: this.range[1],
          // ignore_no_size: this.ignore_no_size ? 1 : 0,
        }
      }).then(response => {
        if (response.data.data.length === 0) {
          this.zoom = 5;
        }
        this.markers = response.data.data
        this.loading = false;
      })
    },
    async getDemographics() {
      if (this.demographicsMarkers.length > 0) {
        for (let m of this.demographicsMarkers) {
          m.setMap(this.$refs.map.$mapObject)
        }
        return;
      }

      if(this.demographicsMarkers.length === 0) {
        const response = await axios.get('/demographics');
        this.demographicsMarkers = response.data.data;
        this.demographicsMarkers = response.data.data.map(item => this.createDemographicsMarker(item));
        await this.$store.dispatch('getDemographics') //todo remove later
      }

      //todo if exists in local store
      // if(this.$store.state.map.demographics.length === 0) {
      //   await this.$store.dispatch('getDemographics')
      // }
      // this.demographicsMarkers = this.$store.state.map.demographics.map(item => this.createDemographicsMarker(item));
      // this.$store.dispatch('getDemographics')
      // this.$http.get('/demographics').then(response => {
      //   // this.demographicsMarkers = response.data.data;
      //   this.demographicsMarkers = response.data.data.map(item => this.createDemographicsMarker(item));
      // })
    },
    async getChargingPointsPaginated() {
      if (this.chargingPointsMarkers.length > 0) {
        for (let m of this.chargingPointsMarkers) {
          m.setMap(this.$refs.map.$mapObject)
        }
        return;
      }

      if(this.chargingPointsMarkers.length === 0) {
        const response = await axios.get('/charging-points');
        let chargingPointsMarkers = response.data.data;

        if (response.data.meta.pagination.total_pages > 1) {
          for (let i = 2; i <= response.data.meta.pagination.total_pages; i++) {
            const chunkResponse = await axios.get('/charging-points', {
              params: {
                page: i,
              }
            });

            chargingPointsMarkers = chargingPointsMarkers.concat(chunkResponse.data.data);
          }
          this.chargingPointsMarkers = chargingPointsMarkers;
          await this.$store.dispatch('getChargingPoints') //todo remove later
          this.chargingPointsMarkers = this.chargingPointsMarkers.map(item => this.createChargingPointsMarker(item));

        }
      }

      // if(this.$store.state.map.chargingPoints.length === 0) {
      //   console.log('getChargingPoints');
      //   await this.$store.dispatch('getChargingPoints')
      // }
      // this.chargingPointsMarkers = this.$store.state.map.chargingPoints.map(item => this.createChargingPointsMarker(item));
      //
      //
      // const response = await this.$http.get('/charging-points');
      // this.chargingPointsMarkers = response.data.data.map(item => this.createChargingPointsMarker(item));
      //
      // let meta = response.data.meta.pagination;
      // if (meta.total_pages > 1) {
      //   for (let i = 2; i <= meta.total_pages; i++) {
      //     const chunkResponse = await this.$http.get('/charging-points', {
      //       params: {
      //         page: i,
      //       }
      //     });
      //
      //     this.chargingPointsMarkers = this.chargingPointsMarkers.concat(
      //       chunkResponse.data.data.map(item => this.createChargingPointsMarker(item))
      //     );
      //   }
      // }

      //?
      // if (this.schemeFilter) {
      //   this.changePlaceByScheme(this.schemeFilter)
      // }
      //select scheme

      this.loading = false;
      // this.updateMap();

    },
    getChargingPoints() {
      if (this.chargingPointsMarkers.length > 0) {
        for (let m of this.chargingPointsMarkers) {
          m.setMap(this.$refs.map.$mapObject)
        }
        return;
      }
      this.$http.get('/charging-points').then(response => {
        // this.demographicsMarkers = response.data.data;
        this.chargingPointsMarkers = response.data.data.map(item => this.createChargingPointsMarker(item));
      })
    },
    async getSchemes() {
      const response = await this.$http.get('/schemes/', {
        params: {
          q: this.schemes.search,
          per_page: 100,
          include: 'address'
        }
      });
      this.schemes.items = response.data.data.map((item) => {
        item.name = item.name + ' (' + item.address.data.full_address + ')';
        return item;
      });
    },
    showEditModal(marker) {
      if (marker.entity_type === 'scheme') {
        this.$refs.editSchemeDialog.showDialog(marker.entity_id);
      }
      if (marker.entity_type === 'property') {
        this.$http.get(`/properties/${marker.entity_id}`).then(response => {
            this.$refs.editPropertyDialog.showDialog(marker.entity_id);
        });
      }
    },
    fitActiveMarkersBounds() {
      this.updateMap();
      // const bounds = new google.maps.LatLngBounds()
      // for (let m of this.activeMarkers) {
      // 	bounds.extend(m.position)
      // }
      // if(this.activeMarkers.length >= 1) {
      // 	this.$refs.map.fitBounds(bounds)
      // }
    },


    addMarker(event) {
        if(!this.placingMarker) {
            return;
        }
        // Add a new marker at the clicked location
        this.propertyMarker = {
            lat: event.latLng.lat(),
            lng: event.latLng.lng()
        };
        this.getAddress();
    },

    dragPropertyMarker(event) {
        // Update the marker position
        this.propertyMarker = {
            lat: event.latLng.lat(),
            lng: event.latLng.lng()
        };
        this.getAddress();
    },

    getAddress() {
      this.addressLoading = true;
      let latlng = { lat: this.propertyMarker.lat, lng: this.propertyMarker.lng };
      let geocoder = new google.maps.Geocoder();
      geocoder.geocode({ 'location': latlng }, (results, status) => {
        if (status === 'OK') {
          if (results[0]) {
            const addressComponents = results[0].address_components;
            this.propertyAddress = {
                line1: '',
                line2: '',
                city: '',
                state: '',
                country: '',
                zip: ''
            };
            const getComponent = (type) =>
            addressComponents.find((component) => component.types.includes(type));

            // Populate address fields
            const streetNumber = getComponent('street_number');
            const route = getComponent('route');
            const locality = getComponent('locality');
            const postalTown = getComponent('postal_town');
            const adminArea = getComponent('administrative_area_level_1'); // State
            const postalCode = getComponent('postal_code');
            const country = getComponent('country');

            // Assign values if the components are found
            this.propertyAddress.line1 = streetNumber && route
                ? `${streetNumber.long_name} ${route.long_name}`
                : route
                ? route.long_name
                : '';
            this.propertyAddress.city = locality ? locality.long_name : postalTown ? postalTown.long_name : '';
            this.propertyAddress.state = adminArea ? adminArea.long_name : '';
            this.propertyAddress.zip = postalCode ? postalCode.long_name : '';
            this.propertyAddress.country = country ? country.long_name : '';
            // delay 0.1s
            setTimeout(() => {
              this.addressLoading = false;
            }, 100);
          } else {
            setTimeout(() => {
              this.addressLoading = false;
            }, 100);
          }
        } else {
            console.log('Geocoder failed due to: ' + status);
            setTimeout(() => {
              this.addressLoading = false;
            }, 100);
        }
      });
    },

    selectAddress(){
      let address = {
        street: this.propertyAddress.line1,
        street2: this.propertyAddress.line2,
        city: this.propertyAddress.city,
        region: this.propertyAddress.state,
        post_code: this.propertyAddress.zip,
        country: this.propertyAddress.country,
        notes: '',
        latitude: this.propertyMarker.lat,
        longitude: this.propertyMarker.lng
      }

      let prefill = {
        address: address,
      }

      if(this.propertyType === 'scheme') {
        this.$refs.addSchemeDialog.openDialog(address, this.propertyMarker);
      } else {
        this.$refs.addPropertyDialog.openDialog(prefill);
      }
    },

    addProperty(type) {
      if (type === 'scheme') {
        this.placingMarker = true;
        this.propertyType = 'scheme';
      } else {
        this.placingMarker = true;
        this.propertyType = 'standalone';
      }
    },

    async mapAdded(data){
      this.clearPropertyMarker()
      this.placingMarker = false;
      console.log(data);
      let marker = this.createPropertyMarker(data);
      this.allMarkers.push(marker);
      this.updateMap();
      // this.getAllDataPaginated();

      // this.allMarkers
    },

    createPropertyMarker(data){
        let full_address = "";
        if(data.address.street){
          full_address += data.address.street + ", ";
        }
        if(data.address.street2){
          full_address += data.address.street2 + ", ";
        }
        if(data.address.city){
          full_address += data.address.city + ", ";
        }
        if(data.address.region){
          full_address += data.address.region + ", ";
        }
        if(data.address.post_code){
          full_address += data.address.post_code;
        }
        return {
          "id": data.id,
          "entity_id": data.id,
          "entity_type": data.entity_type,
          "scheme_name": data.entity_type === 'scheme' ? data.name : null,
          "scheme_id": null,
          "scheme_properties_count": data.entity_type === 'scheme' ? 0 : null,
          "street": data.address.street,
          "street2": data.address.street2,
          "city": data.address.city,
          "region": data.address.region,
          "post_code": data.address.post_code,
          "country": data.address.country,
          "full_address": full_address,
          "logo": null,
          "tenant_name": data.tenant ? data.tenant.name : null,
          "tenant_id": data.tenant ? data.tenant.id : null,
          "position": {
              "lat": data.address.latitude,
              "lng": data.address.longitude,
          }
        }
    },

    clearPropertyMarker() {
        this.propertyMarker = null;
        this.propertyAddress = {
            line1: '',
            line2: '',
            city: '',
            state: '',
            country: '',
            zip: ''
        }
    },


    resetSearch() {
      this.resetSchemeSearch();
      this.resetPlaceSearch();
      this.fitActiveMarkersBounds();
    },

    refreshMap() {
      this.loading = true;
      this.clearAllMarkers();
      this.updateMap();
      setTimeout(() => {
        this.loading = false;
      }, 500);
    },

    resetSchemeSearch() {
      this.schemeFilter = null;
    },
    resetPlaceSearch() {
      this.$refs.autocompleteRef.$refs.input.value = '';
      this.place = '';
      this.placeObject = null;
    },
    zoomToOneMarker() {
      this.$refs.map.$mapObject.setZoom(16);
    },
    debounce(fn, delay) {
      clearTimeout(this._timerId)
      this._timerId = setTimeout(() => {
        fn();
      }, delay);
    },

    rpdMarkerToggle(value) {
      // if(value === true && this.showMarkers === []){
      //   this.showMarkers = ['retail-parks', 'leisure-parks', 'shopping-centres', 'shops'];
      // }


    },

    changeTab(tab) {
      if (tab === this.activeTab){
        this.activeTab = 0;
      }else{
        this.activeTab = tab;
      }
      if (this.activeTab > 0){
        this.drawer = false;
      }else{
        this.drawer = true;
      }
    },
  }
}
</script>

<style scoped>
/*.vue-map-container {*/
/*height: calc(100% - 41px)!important;*/
/*width: 100%;*/
/*}*/

iframe[name='JSD widget'] {

  display: block;

  left: 10px !important;

  bottom: 0px !important;

  z-index: 205 !important;

}

.icon-border{
  /* 2px purple border */
  color: #6d5da4 !important;
  border: 2px solid #6d5da4 !important;
}

.icon-inactive{
  color: rgba(0, 0, 0, 0.54)
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0;
}

</style>
